var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member"},[_c('img',{staticClass:"img",attrs:{"src":"https://ysh-cdn.kaidicloud.com/app/h5/bg1.png"}}),_c('img',{staticClass:"img",attrs:{"src":"https://ysh-cdn.kaidicloud.com/app/h5/bg2.png"}})])
}]

export { render, staticRenderFns }